import { Dispatch, SetStateAction } from "react";
import { GetMarkets200Response } from "../../../codegen-api";
import { LAYER_COLORS } from "../../../constants/design/colors";
import { SPACING } from "../../../constants/design/spacing";
import { getAssetShortName } from "../../../utils/asset/assets";
import { Chevron } from "../../shared/Chevron/style";
import Dropdown from "../../shared/Dropdown";
import { DropdownItem, FiltersContainer } from "./style";

interface IFilterComponentProps {
  toggleTickSizeDropdown: () => void;
  orderbookTickSize?: number;
  perpInstrument?: GetMarkets200Response;
  tickSizeDropdownOpen: boolean;
  availableTickSizes: (number | undefined)[];
  setOrderbookTickSize: Dispatch<SetStateAction<number | undefined>>;
  toggleFilterDropdown: () => void;
  orderbookViewInUSD: boolean;
  filterDropdownOpen: boolean;
  setOrderbookViewInUSD: Dispatch<SetStateAction<boolean>>;
}

function FilterComponent({
  toggleTickSizeDropdown,
  orderbookTickSize,
  perpInstrument,
  tickSizeDropdownOpen,
  availableTickSizes,
  setOrderbookTickSize,
  toggleFilterDropdown,
  orderbookViewInUSD,
  filterDropdownOpen,
  setOrderbookViewInUSD,
}: IFilterComponentProps) {
  return (
    <FiltersContainer>
      <Dropdown
          onToggle={toggleTickSizeDropdown}
          toggleStyles={{
            padding: 0,
            marginRight: SPACING.one,
            backgroundColor: "transparent",
          }}
          dropdownMenuContainerStyles={{
            backgroundColor: LAYER_COLORS.four,
          }}
          title={
            <DropdownItem $selected>
              {orderbookTickSize || perpInstrument?.price_step}
              <Chevron
                size="small"
                direction={tickSizeDropdownOpen ? "up" : "down"}
              />
            </DropdownItem>
          }
          items={availableTickSizes.map((tick) => ({
            label: (
              <DropdownItem $selected={tick === orderbookTickSize}>
                {tick || perpInstrument?.price_step}
              </DropdownItem>
            ),
            onSelect: () => setOrderbookTickSize(tick),
          }))}
        />
        <Dropdown
          onToggle={toggleFilterDropdown}
          toggleStyles={{
            padding: 0,
            marginRight: SPACING.one,
            backgroundColor: "transparent",
          }}
          dropdownMenuContainerStyles={{
            backgroundColor: LAYER_COLORS.four,
          }}
          title={
            <DropdownItem $selected>
              {orderbookViewInUSD
                ? "USD"
                : getAssetShortName(perpInstrument?.underlying_asset) ||
                  perpInstrument?.underlying_asset}
              <Chevron
                size="small"
                direction={filterDropdownOpen ? "up" : "down"}
              />
            </DropdownItem>
          }
          items={[
            {
              label: (
                <DropdownItem $selected={!orderbookViewInUSD}>
                  {getAssetShortName(perpInstrument?.underlying_asset) ||
                    perpInstrument?.underlying_asset}
                </DropdownItem>
              ),
              onSelect: () => setOrderbookViewInUSD(false),
            },
            {
              label: (
                <DropdownItem $selected={orderbookViewInUSD}>USD</DropdownItem>
              ),
              onSelect: () => setOrderbookViewInUSD(true),
            },
          ]}
        />

      {/* <div>
        <OrderbookTypeFilters
          selectedFilterType={orderbookFilter}
          onSelectFilterType={setOrderbookFilter}
        />
      </div> */}
    </FiltersContainer>
  );
}

export default FilterComponent;
